import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, Router } from "@angular/router";
import { RoomInvitationFirstService } from "@youm-front/room/data-access";
import { of } from "rxjs";

@Injectable()
export class RoomInvitationFirstGuard {
  constructor(
    private readonly router: Router,
    private readonly roomInvitationFirstService: RoomInvitationFirstService
  ) {}

  canActivate(route: ActivatedRouteSnapshot) {
    const { roomId } = route.params;

    return this.roomInvitationFirstService.invitationFirstIsDone
      ? of(true)
      : this.router.createUrlTree([roomId, "invitation"], {
          // When using router inside a guard, the queryParamsHandling is not handled.
          queryParams: route.queryParams
        });
  }
}
